import sseService from '../../services/sseService';

/**
 * Vuex plugin to manage SSE connection based on authentication state
 * @param {Object} store - Vuex store instance
 */
export default function ssePlugin(store) {
  let isInitialized = false;

  // Initialize SSE service with store reference
  const initializeSSE = (i18n) => {
    if (!isInitialized && i18n) {
      sseService.init(store, i18n);
      isInitialized = true;

      // Check initial authentication state
      const isAuthenticated = sseService.isAuthenticated();
      if (isAuthenticated) {
        console.log('SSE Plugin: User already authenticated, connecting...');
        sseService.connect();
      }
    }
  };

  // Watch for authentication-related mutations
  store.subscribe((mutation, state) => {
    const { type, payload } = mutation;

    switch (type) {
      case 'SET_USER':
        // User logged in
        if (payload?.data?.token) {
          console.log('SSE Plugin: User login detected');
          sseService.onAuthStateChange(true);
        }
        break;

      case 'SET_USER_DETAILS':
        // User details loaded (authentication confirmed)
        if (payload && Object.keys(payload).length > 0) {
          console.log('SSE Plugin: User details loaded');
          sseService.onAuthStateChange(true);
        }
        break;

      case 'RESET':
        // User logged out or session cleared
        console.log('SSE Plugin: User logout/reset detected');
        sseService.onAuthStateChange(false);
        break;

      default:
        // Check if any mutation affects authentication state
        const wasAuthenticated = sseService.isAuthenticated();

        // Small delay to allow state to update
        setTimeout(() => {
          const isAuthenticated = sseService.isAuthenticated();
          if (wasAuthenticated !== isAuthenticated) {
            console.log(`SSE Plugin: Auth state changed to ${isAuthenticated}`);
            sseService.onAuthStateChange(isAuthenticated);
          }
        }, 100);
        break;
    }
  });

  // Expose initialization method for main.js
  store.$initializeSSE = initializeSSE;

  // Expose SSE service for debugging
  store.$sseService = sseService;

  // Handle page visibility changes to manage connections
  // Note: With BroadcastChannel, only leader tabs reconnect
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        // Check if we should reconnect
        if (sseService.isAuthenticated() && !sseService.isConnected) {
          // Only leader tabs should reconnect
          if (sseService.isLeaderTab) {
            console.log('SSE Plugin: Page visible, leader tab reconnecting...');
            sseService.connect();
          } else {
            console.log('SSE Plugin: Page visible, follower tab waiting for leader...');
          }
        }
      } else if (document.visibilityState === 'hidden' && sseService.isConnected) {
        console.log('SSE Plugin: Page hidden, maintaining connection...');
        // Keep connection alive when page is hidden (only affects leader)
        // Only disconnect on explicit logout or authentication failure
      }
    });
  }

  // Handle beforeunload to cleanup connections
  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', () => {
      sseService.disconnect();
    });
  }
}
